import * as React from 'react';
import { AddButton } from 'ui';
import { MdAdd } from 'react-icons/md';
import { TileWrapper } from 'app/components/tile-wrapper/tile-wrapper';
import { MetadataProps } from '../types';
import { MetadataItem } from './metadata-item';
import styles from './metadata-container.scss';

export const MetadataContainer = (props: MetadataProps) => {
  const { companyReportItem: { metadata } = {}, addMetadata, translation } = props;

  return <TileWrapper>
    <div className={styles.container}>
      {metadata.length > 0
        ? metadata.map(item =>
          <MetadataItem
            key={item.id}
            value={item}
            {...props} />)
        : <p className="no-content">{translation.metadata_no_data}</p>}
      <AddButton icon={MdAdd} onClick={addMetadata}>
        {translation.add_metadata}
      </AddButton>
    </div>
  </TileWrapper>;
};
